import { PriceInfoSection } from "../components/PriceInfoSection";

interface VehicleCardPriceInfoProps {
  expectedPrice: string;
  purchasePrice: string;
  marketPrice: string;
}

export const VehicleCardPriceInfo = ({
  expectedPrice,
  purchasePrice,
  marketPrice,
}: VehicleCardPriceInfoProps) => {
  return (
    <PriceInfoSection
      expectedPrice={expectedPrice}
      purchasePrice={purchasePrice}
      marketPrice={marketPrice}
    />
  );
};
